export default __webpack_public_path__ + "static/media/1418.24837eac.png";